module.exports = __webpack_public_path__ + "img/HURRA.6d545ff8.png";